module.exports = __webpack_public_path__ + "img/features-2.4af25830.png";